import Alpine from 'alpinejs';
import ModalHandler from './modal_handler';
import ScrollLock from '../scroll_lock/scroll_lock';

export const getModalHandlerStore = (scrollLock: ScrollLock): ModalHandler => {
    if (!Alpine.store('modalHandler')) {
        Alpine.store('modalHandler', new ModalHandler(scrollLock));
    }

    return Alpine.store('modalHandler') as ModalHandler;
};
